import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Views/CommonComponent/Header';
import Footer from './Views/CommonComponent/Footer';
import Home from './Views/Pages/Home';
import AboutUs from './Views/Pages/AboutUs';
import OurService from './Views/Pages/OurServicesPages/OurService';
import GetInTouch from './Views/Pages/GetInTouch';
import OurServiceUiUx from './Views/Pages/OurServicesPages/OurServiceUiUx';
import OurWork from './Views/Pages/OurWork';
import ContactUs from './Views/Pages/ContactUs';
import OurInsight from './Views/Pages/OurInsight';
import ScrollToTop from './ScrollOnTop';
const Landing = () => {
  return (
    <>
      <Header />
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/about-us" element={<AboutUs />} /> */}
          {/* <Route path="/our-services-overview" element={<OurService />} />
          <Route path="/our-services-ux-design" element={<OurServiceUiUx />} /> */}
          <Route path="/our-utilities" element={<OurWork />} />
          <Route path="/contact-us" element={<ContactUs />} />
          {/* <Route path="/our-insight" element={<OurInsight />} /> */}
        </Routes>
      </main>
      <GetInTouch />
      <Footer />
    </>
  );
};

export default Landing;
